import { Box, Divider, Skeleton } from '@mui/material';

export const EmployeeDetailsSkeleton = () => {
  return (
    <Box width="100%">
      <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Skeleton variant="circular" width={48} height={48} />
          <Box width="100%">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Skeleton variant="text" width="50%" height={32} />
              <Skeleton variant="text" width="20%" height={24} />
            </Box>
            <Skeleton variant="text" width="70%" height={20} />
          </Box>
        </Box>
      </Box>

      {/* Termination Details Section Skeleton */}
      <Box sx={{ p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Skeleton variant="text" width="40%" height={24} />
          <Skeleton variant="text" width="20%" height={24} />
        </Box>

        <Box sx={{ mt: 3, mb: 2 }}>
          <Skeleton variant="text" width="20%" height={28} />
        </Box>
        <Divider />

        <Box sx={{ py: 1.5 }}>
          <Box display="flex" gap={0.5} alignItems="center" mb={1}>
            <Skeleton variant="text" width="30%" height={20} />
            <Skeleton variant="text" width="50%" height={20} />
          </Box>

          <Box display="flex" gap={0.5} alignItems="center" mb={1}>
            <Skeleton variant="text" width="25%" height={20} />
            <Skeleton variant="text" width="55%" height={20} />
          </Box>

          <Box display="flex" gap={0.5} alignItems="center">
            <Skeleton variant="text" width="25%" height={20} />
            <Skeleton variant="text" width="25%" height={20} />
          </Box>
        </Box>

        {/* Vacation Section Skeleton */}
        <Box sx={{ mt: 3, mb: 2 }}>
          <Skeleton variant="text" width="20%" height={28} />
        </Box>
        <Divider />

        <Box sx={{ py: 1.5 }}>
          <Skeleton variant="text" width="15%" height={28} />

          <Box display="flex" gap={0.5} alignItems="center" mb={1} mt={1}>
            <Skeleton variant="text" width="25%" height={20} />
            <Skeleton variant="text" width="55%" height={20} />
          </Box>

          <Box display="flex" gap={0.5} alignItems="center" mb={1}>
            <Skeleton variant="text" width="25%" height={20} />
            <Skeleton variant="text" width="55%" height={20} />
          </Box>

          <Box display="flex" gap={0.5} alignItems="center" mb={1}>
            <Skeleton variant="text" width="35%" height={20} />
            <Skeleton variant="text" width="10%" height={20} />
          </Box>

          <Box sx={{ mt: 1, width: '30%' }}>
            <Skeleton variant="rounded" height={36} />
          </Box>

          <Box sx={{ mt: 2 }}>
            <Skeleton variant="text" width="40%" height={16} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
